// extracted by mini-css-extract-plugin
export default {"tag":"invoice-table_tag__AC2OQ"};